import {
	listDocumentsHousesHouseIdDocumentsGetOptions,
	getHouseDocumentsStatusV2HousesHouseIdDocumentsV2StatusGetOptions,
} from '@/client/@tanstack/react-query.gen.ts';

function _getHouseDocumentsQueryKey() {
	return (houseId: number) =>
		listDocumentsHousesHouseIdDocumentsGetOptions({
			path: { house_id: houseId },
		}).queryKey;
}

function _getHouseDocumentsStatusQueryKey() {
	return (houseId: number) =>
		getHouseDocumentsStatusV2HousesHouseIdDocumentsV2StatusGetOptions({
			path: { house_id: houseId },
		}).queryKey;
}

export const houseDocumentKeys = {
	list: _getHouseDocumentsQueryKey(),
};

export const houseDocumentStatusKeys = {
	status: _getHouseDocumentsStatusQueryKey(),
};
